<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb(:data="items")
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="true" type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row.py-3(type="flex" justify="center" :gutter="20")
        el-col(:span="12")
          div.my-2.ml-5.title 个人信息：
          el-form(label-width="130px" disabled size="mini")
            el-form-item(label="管理组织")
              span {{supplier.org_name}}
            el-form-item(label="企业名称")
              span {{supplier.name}}
            el-form-item(label="公司地址")
              span {{supplier.address}}
            el-form-item(label="注册资金")
              span {{supplier.registered_funds}}
            el-form-item(label="法人姓名")
              span {{supplier.registrant}}
            el-form-item(label="法人电话")
              span {{supplier.registrant_phone}}
            el-form-item(label="经营范围")
              span {{supplier.scope}}
            el-form-item(label="纳税等级")
              span {{supplier.tax_class}}
            el-form-item(label="纳税等级证明")
              el-image(:src="supplier.img_tax_class" width="125" height="70" :preview-src-list="[supplier.img_tax_class]")
            el-form-item(label="统一社会信用代码")
              span {{supplier.credit_code}}
            el-form-item(label="营业执照许可证")
              el-image(:src="supplier.img_business_license" :preview-src-list="[supplier.img_business_license]" width="125" height="70")
            el-form-item(label="开户行许可证")
              el-image(:src="supplier.img_bank_license" width="125" height="70" :preview-src-list="[supplier.img_bank_license]")
            el-form-item(label="法人身份证")
              el-row(type="flex" justify="center")
                el-col(:span="12")
                  el-image(:src="supplier.img_registrant_id_card" width="125" height="70" :preview-src-list="[supplier.img_registrant_id_card]")
                el-col(:span="12")
                  el-image(:src="supplier.img_registrant_id_card_back" width="125" height="70" :preview-src-list="[supplier.img_registrant_id_card_back]")
            el-form-item(label="注册人身份证")
              el-row(type="flex" justify="center")
                el-col(:span="12")
                  el-image(:src="supplier.img_agent_id_card" width="125" height="70" :preview-src-list="[supplier.img_agent_id_card]")
                el-col(:span="12")
                  el-image(:src="supplier.img_agent_id_card_back" width="125" height="70" :preview-src-list="[supplier.img_agent_id_card_back]")
            //- el-form-item(label="开户行名称")
            //-   span {{supplier.bank_name}}
            //- el-form-item(label="开户行行号")
            //-   span {{supplier.bank_code}}
            //- el-form-item(label="银行账号")
            //-   span {{supplier.bank_account}}
            el-form-item(label="联系人")
              span {{supplier.contact}}
            el-form-item(label="联系电话")
              span {{supplier.contact_phone}}
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          path: "",
          meta: {
            title: "个人中心",
          },
        },
      ],
      h: "",
    };
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
};
</script>